const Terms = () => (
  <div className="min-h-screen bg-background px-6 py-16">
    <div className="max-w-2xl mx-auto space-y-8">
      <h1 className="font-display text-3xl font-bold">Terms of Service</h1>
      <div className="space-y-4 text-sm text-muted-foreground leading-relaxed">
        <p>Last updated: March 2026</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">Service description</h2>
        <p>Brickshare.ai is a pre-diligence screening tool for multifamily real estate investments. It provides deterministic scoring based on user-provided inputs and locked industry benchmarks.</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">Not financial advice</h2>
        <p>Brickshare does not provide investment advice, financial planning, appraisals, or return calculations. Results are screening signals only and should not be the sole basis for any investment decision. Always conduct full due diligence with qualified professionals.</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">Accuracy</h2>
        <p>Results depend entirely on the accuracy of user-provided inputs. Brickshare makes no guarantees about the accuracy, completeness, or reliability of any output.</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">Liability</h2>
        <p>Brickshare shall not be liable for any investment losses, damages, or decisions made based on the outputs of this tool.</p>
        <h2 className="font-display text-lg font-semibold text-foreground pt-4">Contact</h2>
        <p>For questions, contact <a href="mailto:hello@brickshare.ai" className="text-accent hover:underline">hello@brickshare.ai</a>.</p>
      </div>
    </div>
  </div>
);

export default Terms;
